<template>
  <div class="public-header-user-info-modular">
    <div class="header-top-modualr">
      <div class="header-center-modualr">
        <div class="left-item-modular">
          <div class="left-item currency-type-item">
            <!-- <span>USD</span>
            <img class="down-arrow-icon" src="../../assets/public/down-arrow-icon.png" alt="" /> -->
            <div class="currency-list-modualr">
              <el-dropdown
                trigger="click"
                @command="currencyChange"
                @visible-change="changeCurrencyDropdownshow"
              >
                <span class="el-dropdown-link">
                  <span>{{ currCurrency }}</span>
                  <img
                    class="down-arrow-icon2"
                    v-if="currencyDropdownshow"
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                  <img
                    class="down-arrow-icon"
                    v-else
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="index"
                    v-for="(item, index) in rateList"
                    :key="index"
                    >{{ item.currency_name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="left-item">
            <!-- <span>中文简体</span> -->
            <!-- <img class="down-arrow-icon" src="../../assets/public/down-arrow-icon.png" alt="" /> -->
            <div class="language-category-modular">
              <el-dropdown
                trigger="click"
                @command="languageChange"
                @visible-change="changeLanguageDropdownshow"
              >
                <span class="el-dropdown-link">
                  <span>{{ currLanguage }}</span>
                  <img
                    class="down-arrow-icon2"
                    v-if="languageDropdownshow"
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                  <img
                    class="down-arrow-icon"
                    v-else
                    src="../../assets/public/down-arrow-icon.png"
                    alt=""
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="index"
                    v-for="(item, index) in languageList"
                    :key="index"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div class="right-item-modualr">
          <div
            class="right-item"
            @click="toshoppingcart()"
            style="cursor: pointer"
          >
            <img
              class="shop-cart-icon"
              v-if="shopCartNum == 0"
              src="../../assets/public/shopping-cart-icon.png"
              alt=""
            />
            <el-badge :value="shopCartNum" class="item" v-else>
              <img
                class="shop-cart-icon"
                src="../../assets/public/shopping-cart-icon.png"
                alt=""
              />
            </el-badge>
            <span class="shop-cart-text">
              <!-- {{ pageText.cartText }} -->
              {{ pageTextArr[1] }}
            </span>
          </div>
          <div class="right-item signed-item" v-if="isLogin">
            <el-dropdown
              trigger="click"
              @command="handleCommand3"
              @visible-change="changeUserCentereDropdownshow"
            >
              <span class="el-dropdown-link">
                <img
                  class="user-portrait-icon"
                  :src="userInfo.head_img"
                  alt=""
                />
                <span class="userName">{{
                  userInfo.surname + userInfo.name
                }}</span>
                <img
                  class="select-icon2"
                  v-if="userCenterDropdownshow"
                  src="../../assets/public/up-arrow-icon.png"
                  alt=""
                />
                <img
                  class="select-icon"
                  v-else
                  src="../../assets/public/up-arrow-icon.png"
                  alt=""
                />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">
                  <div class="personal-operation-item">
                    <img class="personal-operation-icon" src="../../assets/public/uer-crnter-icon.png" alt="" />
                    {{ pageTextArr[3] }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="2">
                  <div class="personal-operation-item">
                    <img class="personal-operation-icon" src="../../assets/public/login-in-icon.png" alt="" />
                    <!-- {{ pageText.logoutText }} -->
                    {{ pageTextArr[2] }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="right-item" v-else @click="toLogin()">
            <img class="user-portrait-icon" src="../../assets/public/portrait-icon.png" alt="" />
            <span class="user-portrait-text">
              <!-- {{ pageText.loginorrefisterText }} -->
              {{ pageTextArr[4] }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "header",
  data() {
    return {
      currCurrency: "USD", //货币种类
      currLanguage: "简体中文", //语言种类
      currencyDropdownshow: false, //货币下拉选择
      languageDropdownshow: false, //语言下拉选择
      userCenterDropdownshow: false, //语言下拉选择
      equipmentType: 0, //1-手机端,0-pc
      isShowTar: true,
      shopCartNum: 0, //localStorage.getItem('cartCount'),//购物车数量
      activeIndex2: "1",
      searchKey: "",
      searchTar: [
        { title: "高速" },
        { title: "全自动" },
        { title: "贴片机" },
        { title: "飞机相机" },
        { title: "焊锡机" },
        { title: "芯片维修机" },
        { title: "手持式" },
        { title: "通道式" },
        { title: "新光源" },
      ],
      searchTarLength: 8,
      menuTar: [
        { title: "首页", index: "1", path: "/" },
        { title: "产品", index: "2", path: "/productShow" },
        { title: "回流焊系列", index: "3", path: "" },
        { title: "贴片机系列", index: "4", path: "" },
        { title: "拆焊台系列", index: "5", path: "" },
        { title: "关于我们", index: "6", path: "" },
        { title: "博客", index: "7", path: "" },
        { title: "论坛", index: "8", path: "" },
      ],
      isLogin: true,
      userInfo: {}, //用户登录着信息
      // 货币 -汇率
      rateList: [],
      // 预览列表
      languageList: [],
      pageText: {
        personcenterText: '个人中心',
        cartText: '购物车',
        singOutText: '退出登录',
        loginOrRegisterText: '登录/注册'
      },
      pageTextArr: [
        '搜索',
        '购物车',
        '退出登录',
        '个人中心',
        '登录/注册',
        '您还没有登录，请先登录',
        '确定',
    ],
    };
  },
  methods: {
    handleSelect() {},
    toHome() {
      // 跳转商品
      this.$router.push({
        path: "/",
        // query: { name: '', age: '' }
      });
    },
    toPath(path) {
      this.$router.push({
        path: path,
        // query: { name: '', age: '' }
      });
    },
    /**
     * 购物车
     */
     toshoppingcart() {
      this.$router.push({
          path: "/shoppingcart",
        });
      // if (localStorage.getItem("isLogin") == 1) {
      //   this.$router.push({
      //     path: "/shoppingcart",
      //   });
      // } else {
      //   this.$alert(this.pageTextArr[5], "", {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: this.pageTextArr[6],
      //   })
      //     .then(() => {
      //       this.$router.push({
      //         path: "/login",
      //       });
      //     })
      //     .catch((action) => {
      //     });
      // }
    },

    // 个人中心
    toPersonalCenter() {
      this.$router.push({
        path: "/personalCenter",
        // query: { name: '', age: '' }
      });
    },
    // 显示个人操作
    showOperation() {
      this.userCenterDropdownshow = !this.userCenterDropdownshow;
    },
    // 退出-登录页面
    toLogin() {
      // window.localStorage.clear()
      window.localStorage.removeItem('userInfo');
      window.localStorage.removeItem('token');

      localStorage.setItem("isLogin", 0);
      this.$router.push({
        path: "/login",
      });
    },
    // 判断是手机还是PC 更改展示的数据长短
    judgePcOrPhone() {
      let that = this;
      that.equipmentType = localStorage.getItem("equipmentType");
      if (that.equipmentType == 1) {
        // 1-手机端
        that.searchTarLength = 5;
      } else {
        // 0-pc端
        that.searchTarLength = 9;
      }
    },
    // 货币下来选择
    currencyChange(command) {
      // command - 下标index
      let that = this;
      that.currCurrency = that.rateList[command].currency_name;
      // 更改汇率-刷新
      if (that.rateList[command].id != localStorage.getItem("exchangeRateId")) {
        this.$parent.$parent.reload();
      }
      localStorage.setItem("exchangeRateId", that.rateList[command].id);
      localStorage.setItem(
        "currencyName",
        that.rateList[command].currency_name
      );
      localStorage.setItem(
        "currencySymbol",
        that.rateList[command].currency_symbol
      );
      localStorage.setItem(
        "currencyRate",
        that.rateList[command].exchange_rate
      );
    },
    // 货币-显示隐藏
    changeCurrencyDropdownshow(value) {
      this.currencyDropdownshow = value;
    },
    // 语言下拉框点击
    languageChange(command) {
      // command - 下标index
      let that = this;
      that.currLanguage = that.languageList[command].name;
      let oldLanguage = localStorage.getItem("oldLanguageCode");
      if (oldLanguage == '' || oldLanguage == null) {
        localStorage.setItem("oldLanguageCode", that.languageList[command].code);
      } else {
        localStorage.setItem("oldLanguageCode", oldLanguage);
      }
      localStorage.setItem("curLanguageCode", that.languageList[command].code);
      localStorage.setItem("curLanguage", that.languageList[command].name);
      localStorage.setItem("curLanguageType", that.languageList[command].id);
      this.$parent.$parent.reload();
    },
    // 语言-显示隐藏
    changeLanguageDropdownshow(value) {
      this.languageDropdownshow = value;
    },
    // user-center
    handleCommand3(command) {
      let that = this;
      if (command == 1) {
        // 个人中心
        that.toPersonalCenter();
      } else {
        // 退出登录
        that.toLogin();
      }
    },
    // user-center-显示隐藏
    changeUserCentereDropdownshow(value) {
      this.userCenterDropdownshow = value;
    },
    // 汇率列表
    getRateList() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 1000,
      };
      //   // 判断是否已经有语言存在
      if (
        localStorage.getItem("currencyName") != null ||
        localStorage.getItem("currencySymbol") != null ||
        localStorage.getItem("currencyRate") != null
      ) {
        that.rateList = JSON.parse(localStorage.getItem("rateList"));
        that.currCurrency = localStorage.getItem("currencyName");
        return;
      }
      this.$http.getRateList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.rateList = res.data;
            localStorage.setItem("exchangeRateId", that.rateList[0].id);
            localStorage.setItem(
              "currencyName",
              that.rateList[0].currency_name
            );
            localStorage.setItem(
              "currencySymbol",
              that.rateList[0].currency_symbol
            );
            localStorage.setItem(
              "currencyRate",
              that.rateList[0].exchange_rate
            );
            localStorage.setItem("rateList", JSON.stringify(res.data));
            that.currCurrency = that.rateList[0].currency_name;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },
    // 语言列表
    getLanguageList() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 1000,
      };
      // 判断是否已经有语言存在
      // if (
      //   localStorage.getItem("curLanguage") != null ||
      //   localStorage.getItem("curLanguageType") != null
      // ) {
      //   that.languageList = JSON.parse(localStorage.getItem("languageList"));
      //   that.currLanguage = localStorage.getItem("curLanguage");

      //   return;
      // }
      this.$http.getLanguageList(
        data,
        (res) => {
          if (res.ret == 1) {
              that.languageList = res.data;
              if(!localStorage.getItem("curLanguage")){
                localStorage.setItem("curLanguage", that.languageList[0].name);
                localStorage.setItem("curLanguageType", that.languageList[0].id);
                localStorage.setItem("oldLanguageCode", that.languageList[0].code);
                localStorage.setItem("curLanguageCode", that.languageList[0].code);
                localStorage.setItem("curLanguageIndex", 0);
                that.currLanguage=that.languageList[0].name;
              }else{
                that.currLanguage = localStorage.getItem("curLanguage");
              }
              localStorage.setItem("languageList", JSON.stringify(res.data));
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },
    // 用户信息
    getUserInfo() {
      let that = this;
      if (localStorage.getItem("userInfo") != null) {
        that.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        return;
      }
      this.$http.getUserInfo(
        null,
        (res) => {
          if (res.ret == 1) {
            that.userInfo = res.data;
            localStorage.setItem("userInfo", JSON.stringify(res.data));
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
    * 语言翻译
    * @param {*} text 
    */
    languageTranslate(param, text) {
      let that = this;
      let newText = ''
      this.$parent.translate(text,
        (res) => {
          newText = res.data;
          that.pageText[param] = newText;
        }, (res) => {
          newText = '';
        }
      )
    },

    /**
     * 
     * @param {*} param 
     */
    pageTranslate(param) {
      let that = this;
      for (const key in that.pageText) {
        // console.log('key', key);
        // console.log('that.pageText[key]', that.pageText[key]);
        that.languageTranslate(key, that.pageText[key]);
      }
    },

    getLongitudeLatitude() {
      let that = this;
      //如果该对象存在，那么地理位置服务可用。
      if ('geolocation' in navigator) {
        /* 地理位置服务可用 */
        var options = {
          enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
          timeout: 3000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
          maximumAge: 0 //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
        }
        function success(position) {
          //position.coords (只读) 返回一个定义了当前位置的Coordinates对象。
          //position.timestamp (只读) 返回一个时间戳DOMTimeStamp， 这个时间戳表示获取到的位置的时间。
          var lat = position.coords.latitude //当前位置的纬度
          var lng = position.coords.longitude //当前位置精度
          console.log(lat,lng)
          let data = {
            longitude: lng,
            dimension: lat,
          };
          that.getAddress(data)
        }
        function error(err) {
          var errorType = ['您拒绝共享位置信息', '获取不到位置信息', '获取位置信息超时']
          console.log(errorType[err.code - 1])
          let data = {
            longitude: '',
            dimension: '',
          };
          that.getAddress(data)
        }
 
        navigator.geolocation.getCurrentPosition(success, error, options)
      } else {
        /* 地理位置服务不可用 */
        console.log('无法获取您的位置，请检查定位是否开启或刷新重试')
      }

    },
    getAddress(data){
      let that = this;
     
      if(!localStorage.getItem("internalCountry")){
        that.$http.getAddress(
            data,
            (res) => {
              if (res.ret == 1) {
                localStorage.setItem("internalCountry", res.internalCountry);//
                if(res.internalCountry==2){
                  that.languageChange(1);
                }
              }
             
            },
          );
      }
      
    },
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr){
      let that = this
      let newpagetextArr = []
      that.translateByArr(arr,res=>{
        console.log("res",res);
        res.data.forEach((item,index)=>{
          newpagetextArr.push(item.translation)
        })
        that.pageTextArr = newpagetextArr
      })
    },
  },
  mounted() {
    let that = this;
    // that.getLongitudeLatitude();
    that.judgePcOrPhone();
    that.getRateList(); //汇率
    that.getLanguageList(); //语言
    // 用户信息
    that.getUserInfo();
    // 购物车数量
    if (localStorage.getItem('isLogin') == 1) {
      that.shopCartNum = this.number;
    }
    // 当前汇率
    that.currCurrency = localStorage.getItem('currencyName');
    // 翻译
    // that.pageTranslate();
    that.languageTranslateByArrs(that.pageTextArr);
  },
  props: ["number"],
  watch: { 'number'(newValue, oldValue) { this.shopCartNum=newValue; } }
};
</script>

<style lang="scss">
.public-header-user-info-modular {
  width: 100%;
  // height: 35px;

  .header-top-modualr {
    width: 100%;
    padding: 13px 0px;
    background: #f6f6f6;

    .header-center-modualr {
      width: 1200px;
      margin: auto;
      height: 100%;
      // line-height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left-item-modular {
        display: flex;

        .left-item {
          cursor: pointer;
        }

        .left-item span {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
        }

        .down-arrow-icon {
          width: 11px;
          height: 5px;
          margin-left: 6px;
          vertical-align: middle;
        }

        .down-arrow-icon2 {
          transform: rotate(180deg);
          width: 11px;
          height: 5px;
          margin-left: 6px;
          vertical-align: middle;
        }

        .left-item:last-child {
          margin-left: 32px;
        }
      }

      .right-item-modualr {
        display: flex;

        .right-item span {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          margin-right: 10px;
        }

        .right-item {
          cursor: pointer;

          .shop-cart-icon,
          .user-portrait-icon {
            width: 20px;
            height: 20px;
            vertical-align: middle;
            border-radius: 50%;
          }

          .user-portrait-icon {
            width: 26px;
            height: 26px;
            margin-right: 5px;
            position: relative;
            top: -1px;
          }

          .userName {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            margin-right: 2px;
          }

          .select-icon {
            transform: rotate(180deg);
            width: 10px;
            height: 5px;
            vertical-align: middle;
          }

          .select-icon2 {
            width: 10px;
            height: 5px;
            vertical-align: middle;
          }
        }

        .right-item:last-child {
          margin-left: 28px;
        }

        // 操作
        .signed-item {
          position: relative;
          z-index: 10;
        }
      }
    }
  }

  .search-modular {
    width: 100%;
    margin: auto;
    padding-top: 18px;
    padding-bottom: 18px;
    background-color: #ffffff;

    .search-modular-el-row {
      width: 50%;
      margin: auto;
    }

    .left-logo-modular {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .logo-img {
        width: 90%;
        cursor: pointer;
      }
    }

    .right-search-modular {
      width: 90%;
      float: right;

      .search-input-modular {
        .search-input {
          right: 10px;
          width: 100%;
          height: 40px;
          background: #ffffff;
          border: 2px solid #000000;
          border-radius: 20px;

          .el-input__inner {
            background-color: transparent;
            border: 0px;
          }

          .el-input-group__append {
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            border-top-left-radius: 0;
            border-top-right-radius: 20px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 20px;
            background: #000000;
            border: 0;
            right: -2px;
            padding: 0 24px;
          }
        }
      }
    }
  }

  .search-tar-modular {
    display: flex;
    justify-content: space-around;
    margin-top: 12px;
  }
}

.el-dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
}

.personal-operation-item {
  font-size: 16px;
  color: #333;
  // width: 120px;
  text-align: center;
  padding: 5px;
  cursor: pointer;

  .personal-operation-icon {
    width: 18px;
    vertical-align: middle;
    position: relative;
    top: -1px;
    margin-right: 5px;
  }
}

@media screen and (max-width: 500px) {
  .header-top-modualr {
    .header-center-modualr {
      width: 100% !important;

      .left-item-modular {
        justify-content: center;
        width: 50%;
        padding-right: 10px;
        align-items: center;
      }

      .right-item-modualr {
        justify-content: space-between;
        width: 25%;
        padding-right: 10px;
        align-items: center;

        .right-item {
          white-space: nowrap;
          overflow: hide;
          .shop-cart-text {
            display: none;
          }
        }

        .right-item:last-child {
          margin-left: 0 !important;
        }
        .right-item {
          .userName ,.user-portrait-text{
            display: none;
          }
          .select-icon {
            display: none;
          }
        }

        // 操作
        .signed-item {
          position: relative;
          z-index: 10;

          // user-个人中心
          // .personal-operation-modualr {
          //   position: absolute;
          //   top: 30px;
          //   right: 0px;
          //   background-color: #FFFFFF;
          //   border-radius: 10px;
          //   box-shadow: 2px 2px 2px #EEE;
          //   border: 1px solid #EEE;
          //   padding: 5px 0px;

          //   .personal-operation-item {
          //     font-size: 16px;
          //     color: #333;
          //     width: 120px;
          //     text-align: center;
          //     padding: 5px;
          //     cursor: pointer;

          //     .personal-operation-icon {
          //       width: 18px;
          //       vertical-align: middle;
          //       position: relative;
          //       top: -1px;
          //       margin-right: 5px;
          //     }
          //   }
          // }
        }
      }
    }
  }

  .search-modular {
    width: 100% !important;

    .search-modular-el-row {
      width: 100% !important;

      .left-logo-modular {
        .logo-img {
          position: relative;
          top: 10px;
          left: 10px;
        }
      }
    }

    .right-search-modular {
      float: none !important;
      margin: auto;

      .search-input-modular {
        .search-input {
          right: 0px !important;
          height: 30px !important;
        }

        .search-input input {
          height: 30px;
          line-height: 30px;
        }
      }
    }

    .search-tar-modular {
      .el-breadcrumb__item {
        margin-top: 5px;
      }
    }
  }

  // .header-top-tar-modualr {
  //   .el-menu {
  //     display: flex;
  //     justify-content: center;
  //     flex-wrap: wrap;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/public/HeaderUserInfo.vue